import { render, staticRenderFns } from "./sign-up.html?vue&type=template&id=5c4732ea&scoped=true&external"
import script from "./sign-up.js?vue&type=script&lang=js&external"
export * from "./sign-up.js?vue&type=script&lang=js&external"
import style0 from "./sign-up.scss?vue&type=style&index=0&id=5c4732ea&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4732ea",
  null
  
)

export default component.exports